import { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

function SuspenseLoader() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading delay (this is just for demonstration)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Adjust the time as needed

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.7)", // Optional: Add a semi-transparent background
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      {loading ? (
        <>
          <CircularProgress size={64} disableShrink thickness={3} />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Loading...
          </Typography>
        </>
      ) : (
        <Typography variant="h6">Loaded</Typography> // Placeholder when done loading
      )}
    </Box>
  );
}

export default SuspenseLoader;
